import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { canalPadrao } from '@/conversas/canais';

/**
 * Porta de entrada: manda cada papel para a sua área.
 *
 * Não renderiza tela nenhuma — só decide. Antes, esta rota RENDERIZAVA o
 * dashboard do funil, e por isso vivia sob a guarda de Vendas: a recepcionista
 * era barrada ao entrar e caía em "Sem permissão" sem ter pedido nada, porque
 * o login leva todo mundo para "/".
 *
 * Sendo só um desvio, a raiz pode ser aberta a qualquer membro da clínica sem
 * afrouxar nada: quem vai para /dashboard continua passando pela guarda de
 * Vendas na chegada.
 *
 * É também o destino do "Voltar ao início" das telas de status — que por isso
 * agora funciona para os três papéis, e não só para vendas.
 */
export default function InicioPage() {
  const { papel, isSuperadmin } = useAuth();

  // O dono do SaaS não pertence a clínica nenhuma: o funil não teria dados.
  if (isSuperadmin) return <Navigate to="/admin" replace />;

  // A recepção não tem funil nem dashboard — o dia dela começa nas conversas.
  // O canal vem do mapa do inbox, para não fixar a URL em dois lugares.
  if (papel === 'recepcao') return <Navigate to={`/conversas/${canalPadrao(papel)}`} replace />;

  // ★ VU (19/set/2026, TEMPORÁRIO): o Dashboard saiu do menu da equipe, e a raiz
  // não pode levar a SDR para uma tela que ela não alcança — ela entra pela
  // caixa "Conversas — Leads", 1º item do menu dela. REVERTER = apagar esta
  // linha (docs/vu-testes.md, COMO REVERTER); o gestor segue no Dashboard.
  if (papel === 'sdr') return <Navigate to={`/conversas/${canalPadrao(papel)}`} replace />;

  return <Navigate to="/dashboard" replace />;
}
